import { render, staticRenderFns } from "./MResetPassComp.vue?vue&type=template&id=72e32fb2&scoped=true&"
import script from "./MResetPassComp.vue?vue&type=script&lang=ts&"
export * from "./MResetPassComp.vue?vue&type=script&lang=ts&"
import style0 from "./MResetPassComp.vue?vue&type=style&index=0&id=72e32fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e32fb2",
  null
  
)

export default component.exports